// TODO: Add more subcomponents (e.g., EmptyStateImage) once more are needed or when we define the global component in design
import React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const emptyStateVariants = cva("empty-state", {
  variants: {
    size: {
      default: "",
      small: "empty-state--small",
    },
  },
  defaultVariants: {
    size: "default",
  },
})

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof emptyStateVariants> {
  children?: React.ReactNode
  fill?: boolean
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, children, size, fill, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(emptyStateVariants({ size, className }), fill && "empty-state--fill")}
        data-testid="empty-state"
        {...props}
      >
        {children}
      </div>
    )
  },
)

EmptyState.displayName = "EmptyState"

interface EmptyStateBackgroundProps extends React.HTMLAttributes<HTMLDivElement> {
  backgroundUrl?: string
}

const EmptyStateBackground = React.forwardRef<HTMLDivElement, EmptyStateBackgroundProps>(
  ({ className, backgroundUrl, ...props }, ref) => {
    if (!backgroundUrl) return null

    return (
      <div
        ref={ref}
        className={cn("empty-state__background", className)}
        style={{ backgroundImage: `url(${backgroundUrl})` }}
        {...props}
      />
    )
  },
)

EmptyStateBackground.displayName = "EmptyStateBackground"

interface EmptyStateTitleProps extends React.HTMLAttributes<HTMLSpanElement> {}

const EmptyStateTitle = React.forwardRef<HTMLSpanElement, EmptyStateTitleProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <span ref={ref} className={cn("empty-state__title", className)} {...props}>
        {children}
      </span>
    )
  },
)

EmptyStateTitle.displayName = "EmptyStateTitle"

interface EmptyStateDescriptionProps extends React.HTMLAttributes<HTMLSpanElement> {}

const EmptyStateDescription = React.forwardRef<HTMLSpanElement, EmptyStateDescriptionProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <span ref={ref} className={cn("empty-state__description", className)} {...props}>
        {children}
      </span>
    )
  },
)

EmptyStateDescription.displayName = "EmptyStateDescription"

interface EmptyStateActionsProps extends React.HTMLAttributes<HTMLDivElement> {}

const EmptyStateActions = React.forwardRef<HTMLDivElement, EmptyStateActionsProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("empty-state__actions", "mt-4", className)} {...props}>
        {children}
      </div>
    )
  },
)

EmptyStateActions.displayName = "EmptyStateActions"

// Export all components
export { EmptyStateBackground, EmptyStateTitle, EmptyStateDescription, EmptyStateActions, EmptyState }
